import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import bootstrapSession from '@/redux/actions/sessionActions/bootstrapSession.js';

/** Asks once per page load whether this browser is signed in, and loads the account when it is. */
const SessionHandler = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(bootstrapSession());
  }, [dispatch]);

  return null;
};

export default SessionHandler;
